import { Drawer, Grid, ListItemIcon, MenuItem, Select } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import drillXLogo from 'assets/drillx.png';
import energyEfficiencyLogo from 'assets/energy_efficiency_logo.png';
import { ReactComponent as WellGuardianLogo } from 'assets/wg-well-guardian-logo-full.svg';
import Button from 'components/Button';
import TotalLogo from 'components/TotalLogo';
import { APPS } from 'constants/appModules';
import { useIntl } from 'react-intl';

import styles from './Sidebar.module.scss';
import { useSidebar } from './useSidebar';

type Props = {
  isOpen: boolean;
  onSidebarChanged: () => void;
};

const Sidebar = ({ isOpen, onSidebarChanged }: Props) => {
  const intl = useIntl();
  const {
    getStylePerState,
    isOpenDelayed,
    moduleSelectContainer,
    selectedApp,
    onChangeApp,
    isWellGuardianDisabled,
    getSideBarComponentToRender,
  } = useSidebar({ isOpen, onSidebarChanged });

  return (
    <>
      <Drawer
        variant="permanent"
        className={getStylePerState(styles.drawerContainer)}
        anchor="left"
        open={isOpen}
        PaperProps={{
          className: getStylePerState(styles.sidebarPaper),
        }}
      >
        {(isOpen || isOpenDelayed) && (
          <>
            <Grid innerRef={moduleSelectContainer} container item>
              <Select
                className={styles.moduleSelectContainer}
                value={selectedApp}
                inputProps={{
                  classes: {
                    icon: styles.selectIcon,
                  },
                }}
                MenuProps={{
                  classes: {
                    list: styles.menuItem,
                    paper: styles.paperMenu,
                  },
                }}
                onChange={onChangeApp}
              >
                <MenuItem value={APPS.DRILLX_SMART_OPERATIONS}>
                  <ListItemIcon>
                    <TotalLogo className={styles.totalLogo} />
                    <Grid className={styles.menuLabel}>
                      <img className={styles.drillxLogo} alt="DrillX logo" src={drillXLogo} />
                      <p className={styles.logoText}>
                        {intl.formatMessage({ id: 'sidebar.smart' })}{' '}
                        <span className={styles.logoTextOperations}>
                          {intl.formatMessage({ id: 'sidebar.operations' })}
                        </span>
                      </p>
                    </Grid>
                  </ListItemIcon>
                </MenuItem>
                <MenuItem disabled={isWellGuardianDisabled} value={APPS.WELL_GUARDIAN}>
                  <ListItemIcon>
                    <WellGuardianLogo className={styles.wellGuardianLogo} />
                  </ListItemIcon>
                </MenuItem>
                <MenuItem value={APPS.ENERGY_EFFICIENCY}>
                  <ListItemIcon>
                    <img
                      className={styles.energyEfficiencyLogo}
                      alt="DrillX logo"
                      src={energyEfficiencyLogo}
                    />
                  </ListItemIcon>
                </MenuItem>
              </Select>
            </Grid>
            {getSideBarComponentToRender()}
          </>
        )}
      </Drawer>
      <Button className={getStylePerState(styles.toggleDrawerButton)} onClick={onSidebarChanged}>
        <ChevronLeftIcon classes={{ root: getStylePerState(styles.buttonArrow) }} />
      </Button>
    </>
  );
};

export default Sidebar;
